// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl_0qyRRiO48z9IecFqm{flex-direction:column;gap:16px;display:flex}.oPsSUmS7xcq0eTFnH3eY{flex-direction:column;gap:4px;display:flex}.KAj2FPaiTls7Dn48KHrH{padding:12px}.uRVnYP310ZwzEyBmIn9d{color:var(--content-primary-tertiary);align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `vl_0qyRRiO48z9IecFqm`,
	"field": `oPsSUmS7xcq0eTFnH3eY`,
	"textField": `KAj2FPaiTls7Dn48KHrH`,
	"checkbox": `uRVnYP310ZwzEyBmIn9d`
};
export default ___CSS_LOADER_EXPORT___;
